/**
 * The Config tab's small pictures — they move with the number. Extra drops:
 * one ⚡ per extra drop (the chart's mark), then the daily test drop. Space
 * between: a drop · the gap · an extra · the gap · a drop, the gaps growing
 * with the minutes (drawn up to an hour).
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { Zap } from 'lucide-react';

const BOLT = 'h-3.5 w-3.5 fill-primary/30 text-primary';
/** The chart's mark for a drop. */
const Tick: FC = () => <span className="h-6 w-0.5 shrink-0 rounded-full bg-foreground/70" />;

export const ExtrasPicture: FC<{ count: number }> = ({ count }) => (
  <div className="flex min-h-8 flex-wrap items-center gap-1.5" aria-hidden>
    {Array.from({ length: count }, (_, i) => (
      <span key={i} className="flex h-8 w-8 items-center justify-center rounded-md bg-primary/10 duration-300 animate-in fade-in-0 zoom-in-50 motion-reduce:animate-none">
        <Zap className={BOLT} />
      </span>
    ))}
    <span className={`inline-flex h-8 items-center gap-1.5 rounded-md border border-dashed border-primary/40 px-2.5 text-xs text-muted-foreground ${count > 0 ? 'ml-1.5' : ''}`}>
      <Zap className={BOLT} /> test drop
    </span>
  </div>
);

const Gap: FC<{ minutes: number }> = ({ minutes }) => (
  <span className="flex shrink-0 flex-col items-center gap-0.5 px-1 transition-[width] duration-300 ease-out motion-reduce:transition-none" style={{ width: 36 + Math.min(minutes, 60) * 1.6 }}>
    <span className="font-mono text-[11px] tabular-nums text-muted-foreground">{minutes.toLocaleString('en-US')} min</span>
    <span className="flex w-full items-center">
      <span className="h-2 w-px bg-muted-foreground/50" />
      <span className="h-px flex-1 bg-muted-foreground/50" />
      <span className="h-2 w-px bg-muted-foreground/50" />
    </span>
  </span>
);

export const SpacingPicture: FC<{ minutes: number }> = ({ minutes }) => (
  <div className="flex min-h-8 items-end overflow-hidden pb-0.5" aria-hidden>
    <Tick />
    <Gap minutes={minutes} />
    <Zap className={`${BOLT} mb-1 shrink-0`} />
    <Gap minutes={minutes} />
    <Tick />
  </div>
);
